/*!
 * @file 监测后台路由（模块一 P2 骨架）
 * @path src/router/modules/monitor.ts
 *
 * 仅管理员 / 超管可见 —— 由 admin.ts 注入到 adminRoutes 后，
 * 经 store/modules/permission.ts 的 GenerateRoutes 流程下发。
 *
 * 5 个子页面：
 *   01 dashboard   模块一实现
 *   02 api         模块二实现
 *   03 page        模块二实现
 *   04 risk        模块二实现
 *   05 settings    模块二实现
 */

import { RouteConfig } from 'vue-router'

/** 独立框架：不复用运营后台 Layout，自带 sidebar + topbar */
const TechLayout = () => import('@/views/monitor/layout/tech-layout.vue')

const Dashboard       = () => import('@/views/monitor/dashboard/index.vue')
const ApiAnalysis     = () => import('@/views/monitor/api/index.vue')
const PageAnalysis    = () => import('@/views/monitor/page/index.vue')
const RiskMonitor     = () => import('@/views/monitor/risk/index.vue')
const MonitorSettings = () => import('@/views/monitor/settings/index.vue')

const MonitorRoutes: RouteConfig = {
    path: '/monitor',
    component: TechLayout,
    redirect: '/monitor/dashboard',
    meta: {
        title: '技术监测后台',
        hidden: true   // 不进入运营后台侧栏；通过 navbar 上的「系统监测」入口进入
    },
    children: [
        {
            path: 'dashboard',
            name: 'MonitorDashboard',
            component: Dashboard,
            meta: { title: '仪表盘' }
        },
        {
            path: 'api',
            name: 'MonitorApi',
            component: ApiAnalysis,
            meta: { title: '接口分析' }
        },
        {
            path: 'page',
            name: 'MonitorPage',
            component: PageAnalysis,
            meta: { title: '页面分析' }
        },
        {
            path: 'risk',
            name: 'MonitorRisk',
            component: RiskMonitor,
            meta: { title: '风控监测' }
        },
        {
            path: 'settings',
            name: 'MonitorSettings',
            component: MonitorSettings,
            meta: { title: '监测设置' }
        }
    ]
}

export default MonitorRoutes